<template>
  <button
    :class="[textColor, hover, backgroundColor, size, borderStyle]"
    class="uppercase outline-none focus:outline-none p-2 px-4 btnBase"
    :disabled="disabled"
  >
    <slot />
  </button>
</template>

<script>
export default {
  name: "button-base",
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: "white",
      validator: value => {
        return [
          "white",
          "gray",
          "teal",
          "black",
          "pink",
          "red",
          "yellow"
        ].includes(value);
      }
    },
    background: {
      type: String,
      default: "black",
      validator: value => {
        return [
          "gray",
          "teal",
          "white",
          "pink",
          "red",
          "yellow",
          "black"
        ].includes(value);
      }
    },
    size: {
      type: String,
      default: "text-xs"
    },
    borderStyle: {
      type: String
    }
  },
  computed: {
    textColor() {
      return this.color == "black" || this.color == "white"
        ? `text-${this.color}-500`
        : `text-${this.color}-900`;
    },
    backgroundColor() {
      return this.background == "black" || this.background == "white"
        ? `border bg-${this.background}-500`
        : `bg-${this.background}-700`;
    },
    hover() {
      if (this.background == "black") {
        return `hover:bg-red-900`;
      }
      if (this.background == "white") {
        return `hover:bg-gray-100`;
      }

      return `hover:bg-${this.background}-700`;
    }
  }
};
</script>

<style scoped>
.btnBase {
  width: max-content;
}

.bg-yellow-700 {
  background: rgba(180, 83, 9, 0.8);
}

.btnBase[disabled] {
  background: grey;
  cursor: default;
}
</style>
